import request from './request';
import deserialize from './deserialize';

export type StampCard = {
  id: string;
  createdAt: number;
  quantity: number;
  redemptionCost: number;
  status: string;
  updatedAt: number;
  slotNumber: number;
  stampCampaignName: string;
  stampCampaignType: string;
  stampCampaignDescription: string;
  showVisitedStores: boolean;
  loyalty_campaign: {
    type: 'loyalty_campaigns';
    id: string;
  };
  merchant: {
    type: 'merchants';
    id: string;
  };
  reward: {
    data: {
      type: 'rewards';
      id: string;
    };
  };
};

export type MemberStampCard = {
  id: string;
  createdAt: string;
  quantity: number;
  redemptionCost: number;
  status: string;
  updatedAt: string;
  slotNumber: number;
  stampCampaignName: string;
  stampCampaignType: string;
  stampCampaignDescription: string;
  merchantId: string;
  showVisitedStores: boolean;
  loyalty_campaign: {
    ID: string;
  };
  reward: {
    ID: string;
  };
};

export type StampCardList = {
  id: string;
  merchantID: string;
  stampCards: MemberStampCard[];
}[];

export type StoreInfo = {
  ID: string;
  Name: string;
  Count: number;
};

export type StoreVisitList = {
  nonVisitedStores: StoreInfo[];
  visitedStores: StoreInfo[];
};

export function list() {
  return request<StampCardList>({
    url: '/api/v3/stamp_cards',
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function get(stampCardId: string) {
  return request<StampCard>({
    url: `/api/v3/stamp_cards/${stampCardId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function getByMerchantId(merchantId: string) {
  return request<StampCard>({
    url: `/api/v3/merchants/${merchantId}/stamp_card`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function listByMerchantId(merchantId: string) {
  return request<StampCard[]>({
    url: `/api/v3/merchants/${merchantId}/stamp_cards`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function creditStampCard(
  stampCardId: string,
  pinCode: string,
  stampNum: number,
) {
  return request<StampCard>({
    url: `/api/v3/stamp_cards/${stampCardId}/credit`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          pin: pinCode,
          numOfStamps: stampNum,
        },
      },
    },
    transformResponse: deserialize,
  });
}

export function create(merchantId: string) {
  return request<StampCard>({
    url: `/api/v3/merchants/${merchantId}/stamp_card`,
    method: 'POST',
    data: {
      data: {
        type: 'stamp_cards',
        attributes: {
          source: 'scan',
        },
      },
    },
    transformResponse: deserialize,
  });
}

export function creditStampCardContactless(contactlessCode: string) {
  return request<StampCard>({
    url: `/api/v3/stamp_cards/credit/contactless`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          code: contactlessCode,
        },
      },
    },
    transformResponse: deserialize,
  });
}

export function creditStampCardSingleUse(
  singleUseCode: string,
  storeId: string,
  numOfStamps: number,
  merchantId: string,
) {
  return request<StampCard>({
    url: `/api/v3/merchants/${merchantId}/credit/single_use`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          code: singleUseCode,
          storeID: storeId,
          numOfStamps,
        },
      },
    },
    transformResponse: deserialize,
  });
}

export function getStampCardByCampaignAndSlot(
  stampCampaignId: string,
  slotNumber: number,
) {
  return request<StampCard>({
    url: `/api/v3/stamp_campaign/${stampCampaignId}/slot/${slotNumber}/stamp_card`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function archiveStampCard(stampCardId: string) {
  return request({
    url: `/api/v3/stamp_cards/${stampCardId}/archive`,
    method: 'DELETE',
    transformResponse: deserialize,
  });
}

export function trackStoresVisited(merchantId: string, stampCardId: string) {
  return request<StoreVisitList>({
    url: `/api/v3/merchants/${merchantId}/stamp_cards/${stampCardId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
